import { type FormInstance, type Rule } from "antd/lib/form"
import { checkDueInDays, checkMaxNumber, checkMinNumber } from "~Components/forms/rules/utils.rules"
import { TablesEnum } from "~Shared/store/reducers/tableConfigReducer"
import { ExportDateFilterEnum } from "~Shared/utils/exportDateFilter.enum"
import { insertIf } from "~Shared/utils/helper.utils"

export const createExpenseFilterRules = ({
    formInstance,
    table,
    archiveDateFilter,
}: {
    formInstance: FormInstance
    table?: TablesEnum
    archiveDateFilter?: ExportDateFilterEnum
}) => {
    const isArchiveInvoiceDateFilter = table === TablesEnum.ARCHIVE && archiveDateFilter === ExportDateFilterEnum.INVOICE
    const isArchivePerformanceDateFilter = table === TablesEnum.ARCHIVE && !isArchiveInvoiceDateFilter

    return {
        minAmount: [
            {
                validator: (_rule, value: number | string) => checkMinNumber({ formInstance, value, name: "maxAmount" }),
            },
        ] as Array<Rule>,
        maxAmount: [
            {
                validator: (_rule, value: number | string) => checkMaxNumber({ formInstance, value, name: "minAmount" }),
            },
        ] as Array<Rule>,
        minDate: [...insertIf(isArchivePerformanceDateFilter, { required: true })] as Array<Rule>,
        maxDate: [...insertIf(isArchivePerformanceDateFilter, { required: true })] as Array<Rule>,
        minInvoiceDate: [...insertIf(isArchiveInvoiceDateFilter, { required: true })] as Array<Rule>,
        maxInvoiceDate: [...insertIf(isArchiveInvoiceDateFilter, { required: true })] as Array<Rule>,
        dueInDays: [
            {
                validator: (_rule, value: number | string) => checkDueInDays(value),
            },
        ] as Array<Rule>,
    }
}
